// Main detection function
const detectTimesFromInput = (input) => {
  const timePatterns = [
    {
      text: "in summer",
      season: "summer",
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    { text: "in winter", season: "winter", months: [11, 0, 1] },
    { text: "in spring", season: "spring", months: [3, 4, 9, 10, 11, 1, 2] },
    { text: "in autumn", season: "autumn", months: [3, 4, 9, 10, 11, 1, 2] },
  ];

  const rangeRegex =
    /(?:from|between)\s*(\d{1,2})(?:[:.]\d{2})?\s*(am|pm)?\s*(?:to|and)\s*(\d{1,2})(?:[:.]\d{2})?\s*(am|pm)?/gi;
  const singleTimeRegex =
    /(?:at|around|about|near|by|o'clock)?\s*(\d{1,2})(?:[:.]\d{2})?\s*(am|pm)?/gi;
  const periodRegex = /\b(morning|afternoon|evening|noon)\b/gi;

  const mapToValidRange = (hour) => (hour >= 1 && hour <= 6 ? hour + 12 : hour);

  const parseTimes = (input) => {
    const hours = [];
    let match;

    // Parse ranges
    while ((match = rangeRegex.exec(input)) !== null) {
      let start = parseInt(match[1], 10);
      let end = parseInt(match[3], 10);
      const startPeriod = match[2]?.toLowerCase();
      const endPeriod = match[4]?.toLowerCase();
      if (startPeriod === "pm" && start < 12) start += 12;
      if (startPeriod === "am" && start === 12) start = 0;
      if (endPeriod === "pm" && end < 12) end += 12;
      if (endPeriod === "am" && end === 12) end = 0;
      start = mapToValidRange(start);
      end = mapToValidRange(end);
      if (start < end) {
        hours.push(
          ...Array.from({ length: end - start + 1 }, (_, i) => start + i)
        );
      }
    }

    // Parse single times
    while ((match = singleTimeRegex.exec(input)) !== null) {
      let hour = parseInt(match[1], 10);
      const period = match[2]?.toLowerCase();
      if (period === "pm" && hour < 12) hour += 12;
      if (period === "am" && hour === 12) hour = 0;
      hour = mapToValidRange(hour);
      if (!hours.includes(hour)) {
        hours.push(hour);
      }
    }

    // Parse periods like morning, afternoon, etc.
    while ((match = periodRegex.exec(input)) !== null) {
      const period = match[1].toLowerCase();
      const periodToHours = {
        morning: [7, 8, 9],
        noon: [11, 12, 13],
        afternoon: [14, 15, 16],
        evening: [17, 18, 19],
      };
      if (periodToHours[period]) {
        hours.push(...periodToHours[period]);
      }
    }

    // Constrain to 7–19 range
    return hours
      .filter((hour) => hour >= 7 && hour <= 19)
      .sort((a, b) => a - b);
  };

  const detectedTimes = [];

  // Match for the single shadow context trigger
  const shadowPattern = /\bmy site is shadowed\b/i;
  if (shadowPattern.test(input)) {
    timePatterns.forEach((pattern) => {
      const patternRegex = new RegExp(`\\b${pattern.text}\\b`, "i");
      if (patternRegex.test(input)) {
        const hours = parseTimes(input);
        if (hours.length > 0) {
          detectedTimes.push({
            hours,
            months: pattern.months,
            season: pattern.season,
          });
        }
      }
    });
  }
  return detectedTimes;
};

// Test Cases
const testCases = [
  "My site is shadowed at 5 PM in summer.",
  "My site is shadowed from 8 AM to 10 AM in winter.",
  "My site is shadowed in the morning during spring.",
  "My site is shadowed around noon in autumn.",
  "My site is shadowed in the afternoon in summer.",
];

// Run Test Cases

module.exports = { detectTimesFromInput };
